// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos personalizados para o relatório de distribuição de receita */
.report-container {
  background-color: #f4f6f9;
  min-height: 100vh;
  padding: 20px;
}

.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.report-title {
  color: #333;
  font-weight: bold;
  margin-bottom: 0;
}

.container-reports {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  height: 100%;
  margin-top: 20px;
}

.payment-table tbody tr:hover {
  background-color: #f1f3f5;
  transition: background-color 0.3s ease;
}

.total-revenue {
  background-color: #e9ecef;
  padding: 10px;
  border-radius: 5px;
  font-weight: bold;
}

.filter-section {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.add-payment-btn {
  background-color: #28a745;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-payment-btn:hover {
  background-color: #218838;
}
.component-pagamento {
  display: flex;
  justify-content: space-between;
  background-color: rgb(66, 66, 66);
  color: white;
  height: 100px;
  padding: 20px;
  align-items: center;
  border-radius: 15px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}
.container-reports-content {
  height: 50vh;
  overflow-y: auto;
}

.component-pagamento p {
  display: flex;
  flex-direction: column;
  margin: 0;
  font-size: 14px;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/views/componentCss/ReportRevenueDistribution.css"],"names":[],"mappings":"AAAA,uEAAuE;AACvE;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* Estilos personalizados para o relatório de distribuição de receita */\n.report-container {\n  background-color: #f4f6f9;\n  min-height: 100vh;\n  padding: 20px;\n}\n\n.report-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.report-title {\n  color: #333;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.container-reports {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  height: 100%;\n  margin-top: 20px;\n}\n\n.payment-table tbody tr:hover {\n  background-color: #f1f3f5;\n  transition: background-color 0.3s ease;\n}\n\n.total-revenue {\n  background-color: #e9ecef;\n  padding: 10px;\n  border-radius: 5px;\n  font-weight: bold;\n}\n\n.filter-section {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.add-payment-btn {\n  background-color: #28a745;\n  color: white;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.add-payment-btn:hover {\n  background-color: #218838;\n}\n.component-pagamento {\n  display: flex;\n  justify-content: space-between;\n  background-color: rgb(66, 66, 66);\n  color: white;\n  height: 100px;\n  padding: 20px;\n  align-items: center;\n  border-radius: 15px;\n  margin-bottom: 10px;\n  transition: background-color 0.3s ease;\n}\n.container-reports-content {\n  height: 50vh;\n  overflow-y: auto;\n}\n\n.component-pagamento p {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
